type TransactionItem = {
  title: string;
  value: string | null;
  additionalClass: string;
  isInvoices?: boolean;
};

export const makeTransactionItems = (
  subtotal: string,
  taxes: string,
  flatFees: string,
  discount: string,
  total: string,
  paidAmount: string,
): Record<string, TransactionItem> => ({
  subtotal_hold: {
    title: 'Subtotal',
    value: subtotal,
    additionalClass: '',
  },
  flat_fees_hold: {
    title: 'Flat Fees',
    value: flatFees,
    additionalClass: '',
  },
  taxes_hold: {
    title: 'Taxes',
    value: taxes,
    additionalClass: '',
  },
  discount_hold: {
    title: 'Discount',
    value: discount,
    additionalClass: '',
  },
  total_hold: {
    title: 'Total',
    value: total,
    additionalClass: 'total',
  },
  paid_amount_hold: {
    title: 'Paid Amount',
    value: paidAmount,
    additionalClass: 'paidAmount',
  },
  invoices_hold: {
    title: 'Invoices',
    value: null,
    additionalClass: 'invoices',
    isInvoices: true,
  },
});

export const declineEventRadioLabelsB2C = [
  {
    FormControlLabelValue: 'countTooLow',
    FormControlLabelLabel: 'Guest count too low',
  },
  {
    FormControlLabelValue: 'budgetTooLow',
    FormControlLabelLabel: 'Budget too low',
  },
  {
    FormControlLabelValue: 'specifiedDateTime',
    FormControlLabelLabel: 'Not available on specified Date/Time',
  },
  {
    FormControlLabelValue: 'specifiedServices',
    FormControlLabelLabel: 'Unable to provide specified services',
  },
  {
    FormControlLabelValue: 'outOfService',
    FormControlLabelLabel: 'Event out of service area/city',
  },
  { FormControlLabelValue: 'other', FormControlLabelLabel: 'Other' },
];